import { InlineMessage } from '@strata/react-inline-message';
import PropTypes from 'prop-types';

export const BulkChangeWarningMessage = ({ apiQueryParams = undefined, treatmentsCount = 0 }) =>
    !apiQueryParams?.treatmentId ? (
        <InlineMessage
            intent={InlineMessage.Intent.WARNING}
            label={`This change will be applied to all ${treatmentsCount} treatments that match the current filter set.`}
            wrapText
        />
    ) : null;

BulkChangeWarningMessage.propTypes = {
    apiQueryParams: PropTypes.shape({
        treatmentId: PropTypes.string,
    }),
    treatmentsCount: PropTypes.number,
};
